<template>
<sidebar-widget
    :start-expanded="startExpanded"
    :sections="sections"
    :headers="['Tier', 'Employee Cost', 'Employer Cost']"
>
    <template v-slot:title>Costs</template>

    <template v-slot:headerbutton>
        <button class="btn btn-outline-primary" type="button" @click.prevent.stop="editModalOpen = true">
            <i class="far fa-pen" aria-hidden="true" title="Edit"></i>&nbsp;
            <slot name="add-button">Edit</slot>
        </button>

        <cost-modal
            v-if="editModalOpen"
            :client="client"
            :insurance-plan="insurancePlan"
            @updated="onUpdate"
            @close="editModalOpen = false"
        />
    </template>

    <template v-slot:row-details="props">
        <div>
            <span>Total Cost: </span> <span>${{ props.row.total_cost }}</span><br />
            <span>Employee Cost: </span> <span>${{ props.row.employee_cost }}</span><br />
            <span>Employer Cost: </span> <span>${{ props.row.employer_cost }}</span><br />
        </div>
    </template>
</sidebar-widget>

</template>

<script>
import SidebarWidget from './SidebarWidget'
import CostModal from './CostModal'

export default {
    props: ['insurancePlan', 'startExpanded', 'client', ],
    components: {SidebarWidget, CostModal, },
    computed: {
        sections() {
            const rows = []

            function addTier(name, totalCost, employeeCost, employerCost) {
                const row = {
                    total_cost: totalCost,
                    employee_cost: employeeCost,
                    employer_cost: employerCost,
                    tier: name,
                }

                row.id = Math.random()
                row.cells = [
                    name,
                    '$' + employeeCost,
                    '$' + employerCost,
                ]
                rows.push(row)
            }

            const p = this.insurancePlan

            if (p.billing_type == 'flat') {
                addTier('Single', p.single_total_cost, p.single_employee_cost, p.single_employer_cost)

                if (p.has_single_plus_one) {
                    addTier('Single + 1', p.single_plus_one_total_cost, p.single_plus_one_employee_cost, p.single_plus_one_employer_cost)
                }

                if (p.has_single_plus_children) {
                    addTier('Single + children', p.single_plus_children_total_cost, p.single_plus_children_employee_cost, p.single_plus_children_employer_cost)
                }

                if (p.has_family) {
                    addTier('Family', p.family_total_cost, p.family_employee_cost, p.family_employer_cost)
                }
            }
            else if (p.billing_type == 'age-band') {
                const ageBands = {}

                p.insurance_plan_age_bands.forEach(ab => {
                    ageBands[ab.age] = ab
                })

                for (let i = 14; i <= 64; i++) {
                    const ageBand = ageBands[i] ? ageBands[i] : {total_cost: '0.00', employee_cost: '0.00', employer_cost: '0.00'}
                    addTier(i, ageBand.total_cost, ageBand.employee_cost, ageBand.employer_cost)
                }
            }

            return [{title: 'Main', rows: rows}]
        },
    },
    data() {
        return {
            editModalOpen: false,
        }
    },
    methods: {
        onUpdate(obj) {
            if (obj) {
                Object.assign(this.insurancePlan, obj)
                this.$emit('updated', obj)
            }
            else {
                this.$emit('updated')
            }
        },
    },
}
</script>


